import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import {
  getApiClient,
  initializeApiClient,
} from "../../../Services/apiService";

export const GetAllSubTaskByMain = createAsyncThunk(
  "GetAllSubTaskByMain",
  async (taskFlowGUID, { rejectWithValue }) => {
    try {
      await initializeApiClient();
      const apiClient = await getApiClient();
      const response = await apiClient.post(
        "api/SubTaskFlow/GetAllSubTaskByMain",
        {
          taskFlowGUID: taskFlowGUID,
        }
      );

      // Extract data from the response object
      const data = response.data.result; // Assuming response has a "data" field
      //console.log(data, "GetAllSubTaskByMain");

      return data; // Return the extracted data
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

const AllSubTaskByMain = createSlice({
  name: "AllSubTaskByMain",
  initialState: {
    AllSubTaskByMain: [],
    loadingAllSubTaskByMain: false,
    errorAllSubTaskByMain: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(GetAllSubTaskByMain.pending, (state, action) => {
        state.loadingAllSubTaskByMain = true;
        state.AllSubTaskByMain = action.payload;
        state.errorAllSubTaskByMain = null;
      })
      .addCase(GetAllSubTaskByMain.fulfilled, (state, action) => {
        state.loadingAllSubTaskByMain = false;
        state.AllSubTaskByMain = action.payload;
      })
      .addCase(GetAllSubTaskByMain.rejected, (state, action) => {
        state.loadingAllSubTaskByMain = false;
        state.errorAllSubTaskByMain = action.payload;
      });
  },
});

export default AllSubTaskByMain.reducer;
